module.exports = __webpack_public_path__ + "static/media/eye-of-the-storm.53f3240e.gif";